import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import arrow from '../../img/arrow1.png'
import CalendarIcon from "../../img/calendaricon.svg";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";
import {instance, instance2} from '../../utils/axiosInstance'
import { formatNumber } from "../../numberingformat";
import { useLocation, useNavigate } from 'react-router-dom'
import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { ReactComponent as ListOn } from '../../img/CheckCircle.svg'

import { ReactComponent as ArrowIcon } from "../../img/arrowicon.svg";


export default function DaftarMenuMingguan(){
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [purchaseOrder, setPurchaseOrder] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
    const itemsPerPage = 9; // Number of items per page
      const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  //const [selectedDate, setSelectedDate] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);


    
  const localDateString = (thedate) =>{
  
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, '0');
    
  console.log("startDate", thedate);
  const localDateString = `${year}-${month}-${day}`;
  
  return localDateString
  
  }

  // const [weekDetails, setWeekDetails] = useState({
  //   weekNumber: 1,
  //   startDate: "",
  //   endDate: "",
  // });
  
const roleId = parseInt(localStorage.getItem('roleId'),10); 

  const [locationId, setLocationId] = useState("");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [draftOrder, setDraftOrder] = useState([]);
  const [additionalSuppliers, setAdditionalSuppliers] = useState([]);

  const handleAddSupplier = () => {
    setAdditionalSuppliers((prev) => [
      ...prev,
      { supplier_id: null, quantity: null },
    ]);
  };
  
  const handleAdditionalSupplierChange = (value, index) => {
    const updatedSuppliers = [...additionalSuppliers];
    updatedSuppliers[index].supplier_id = parseInt(value, 10) || null;
    setAdditionalSuppliers(updatedSuppliers);
  };

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
  
    const handleBuatPesanan = async (startDate, endDate) => {
      //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
  
      // console.log('User Authentication:', userAuthentication);
     console.log('Location ID (as integer):', locationId);
  
      try {
        const requestBody = {
          location_id: locationId,
          startdate: localDateString(new Date(startDate)),
          enddate: localDateString(new Date(endDate)),
          admin_id: adminId,
        };
  
        const response = await instance2.post(
          "/ingredient_location",
          requestBody,
        );
        // console.log("/ingredient_location", requestBody);
        if (response.status === "OK") {
          console.log("Success:", response.data);
          setPopupMessage("Data telah tersimpan");
          setIsPopupVisible(true); // Show the popup
  
          //console.log(`/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
          navigate(
            `/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`,
          );
        } else {
          console.error("Error:", response.data);
          setPopupMessage("Gagal menyimpan data");
          setIsPopupVisible(true); // Show the popup
        }
      } catch (error) {
        console.error("Network Error:", error);
        setPopupMessage("An error occurred while submitting the data.");
        setIsPopupVisible(true); // Show the popup
      }
    };
  
  
  
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await instance2.get("supplier"); // Use instance2 for the API call
        setSuppliers(response.data); // Axios automatically parses JSON, accessing response.data directly
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      }
    };
  
    fetchSuppliers();
  }, []);
  
  
  useEffect(() => {
    const storedLocationId = localStorage.getItem("locationId");
  
    if (storedLocationId && !isNaN(storedLocationId)) {
      const parsedId = parseInt(storedLocationId, 10);
      setLocationId(parsedId);
    }
  }, []);

    // Access state from the navigate call
    const location = useLocation();
  
    // Extract startDate and endDate from the URL query string
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
  
    const locId = localStorage.getItem("locationId")

    useEffect(() => {
      if (startDate&& endDate){ 
      const fetchPurchaseOrder = async () => {
        try {
          const response = await instance2.get(`purchase_order/location/${locId}/${startDate}/${endDate}`); // Use instance2 for the API call
          setPurchaseOrder(response.data); // Axios automatically parses JSON, accessing response.data directly
          console.log("goooo1");
          
        } catch (error) {
          console.error("Error fetching purchase order:", error);
        }
      };
    
      fetchPurchaseOrder();
    }
    }, []);
    
    if(purchaseOrder.length>0){ 
      //console.log("goooo2");
      navigate(`/daftarpemesanan?startDate=${startDate}&endDate=${endDate}`)} else {
        //console.log("goooo3",purchaseOrder.length)
      } 
    

  const getWeekStartAndEndDates = (date) => {
    const current = new Date(date);
    const dayOfWeek = current.getDay(); // Get the day of the week (0 - Sunday, 6 - Saturday)
  
    // Calculate Monday (start of the week)
    const monday = new Date(current);
    monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
  
    // Calculate Friday (end of the week)
    const friday = new Date(monday);
    friday.setDate(monday.getDate() + 4);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
  
    return { startDate: monday, endDate: sunday };
  };

  useEffect(() => {
    if (!locationId) {
      console.log("Location ID not yet available.");
      return; // Do not fetch data until locationId is set
    }
  
    //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
  
    const localDateString = (thedate) =>{

      const year = thedate.getFullYear();
      const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
      const day = String(thedate.getDate()).padStart(2, '0');
      
    console.log("startDate", thedate);
    const localDateString = `${year}-${month}-${day}`;
    
    return localDateString
    
    }

    const fetchData = async () => {
      try {
        const response = await instance2.get(
          `ingredient_location/${locationId}/${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`
        ); // Use instance2 for the API call
  // console.log(
  //   `ingredient_location/${locationId}/${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`)
  //       console.log("response", response.data);
  //       console.log("rawdate", response.data[0].date)
  //       console.log("rawdate2", localDateString(new Date(response.data[0].date)))
        setData(response.data); // Access the data directly from Axios response
        setLoading(true)
        console.log("res",response.data.length)
        if(response.data.length===0){


          //alert("Tidak ada data pesanan. Kembali ke menu mingguan.");
           // Wait 5 seconds before navigating
          //  setTimeout(() => {// Hide loading message
            //navigate(`/draftOrder/`);
          // }, 1000); 
        }
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch data");
        
         
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [locationId, startDate]); // Trigger API call when locationId or selectedDate changes

  const groupedData = data.reduce((acc, item) => {
    const date = localDateString(new Date(item.date)); // Extract the date part
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);
    return acc;
  }, {});


  // const getWeekDetails = (date) => {
  //   console.log("Input date:", date);
  
  //   // Ensure the input is converted to a Date object if it's not already
  //   const currentDate = startDate? new Date(startDate) : new Date(date);
  //   if (isNaN(currentDate)) {
  //     console.error("Invalid date provided:", date);
  //     return {
  //       weekNumber: null,
  //       monthName: null,
  //       startDate: null,
  //       endDate: null,
  //     };
  //   }
  
    // console.log("Parsed date:", currentDate);
  
    // const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // Start of the month
    // const dayOfWeek = currentDate.getDay();
  
    // Calculate the start of the week (Monday)
    //const startDate = new Date(currentDate);
    // const diff = startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Monday
    // startDate.setDate(diff);
  
    // console.log("Calculated startDate:", startDate);
  
    // Calculate the end of the week (Friday)
    // const endDate = new Date(startDate);
    // //endDate.setDate(startDate.getDate() + 4); // Friday is 4 days after Monday
    // endDate.setDate(startDate.getDate() + 6); // Sunday is 4 days after Monday
    // console.log("Calculated endDate:", endDate);
  
    // Calculate the week number of the month
    // const daysSinceStartOfMonth = Math.floor((startDate - startOfMonth) / (1000 * 60 * 60 * 24));
    // const weekNumber = Math.ceil((daysSinceStartOfMonth + 1) / 7);
    // console.log("Week number:", weekNumber);
  
    // Month Names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
  
    // const monthName = monthNames[startDate.getMonth()]; // Use startDate for the month name
    // console.log("Month name:", monthName);

  //   const localDateString = (thedate) =>{

  //     const year = thedate.getFullYear();
  //     const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
  //     const day = String(thedate.getDate()).padStart(2, '0');
      
  //   console.log("startDate", thedate);
  //   const localDateString = `${year}-${month}-${day}`;
    
  //   return localDateString
    
  //   }

  //   return {
  //     weekNumber,
  //     monthName,
  //     startDate: localDateString(startDate),
  //     endDate: localDateString(endDate),
  //   };
  // };

  const handleQuantityChange = (index, value) => {
    const updatedSuppliers = [...additionalSuppliers];
    updatedSuppliers[index].quantity = parseInt(value, 10) || 0;
    setAdditionalSuppliers(updatedSuppliers);
  };

  const enrichedSelectedRowData = selectedRowData
  ? {
      ...selectedRowData,
      supplier_quantity: selectedRowData.supplier_quantity || selectedRowData.order_qty,
    }
  : null;

const enrichedAdditionalSuppliers = additionalSuppliers.map((supplier) => ({
  ...supplier,
  quantity: supplier.quantity || 0,
}));

useEffect(() => {
  // Other effects that don't modify state
}, [enrichedSelectedRowData, enrichedAdditionalSuppliers]);

  
  
  
  const totalSupplierQuantity = () => {
    if (!selectedRowData) return 0;
  
    return (
      parseInt(selectedRowData.supplier_quantity || 0, 10) +
      additionalSuppliers.reduce(
        (acc, supplier) => acc + (parseInt(supplier.quantity || 0, 10)),
        0
      )
    );
  };
  
  
// Update week details when the selected date changes
// useEffect(() => {
//     const { weekNumber, startDate, endDate } = getWeekDetails(startDate);
//     setWeekDetails({ weekNumber, startDate, endDate });
//   }, [selectedDate]);
  
//   const CustomInput = React.forwardRef(({ onClick, isOpen }, ref) => (
//     <button
//       className="flex items-center justify-between w-full px-4 py-2 border-none rounded-[15px] bg-white"
//       onClick={onClick}
//       ref={ref}
//       type="button"
//     >
//       {/* Left Section: Calendar Icon */}
//       <div className="flex items-center gap-2">
//       <img src={CalendarIcon} alt="Calendar" className="h-5 w-5 text-gray-500" />
  
//   {/* Separator */}
//   <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
//         <span>
//           {new Date(selectedDate).toLocaleDateString("id-ID", {
//             year: "numeric",
//             month: "long",
//             day: "2-digit",
//           })}
//         </span>
//       </div>
  
//       {/* Right Section: Rotating Arrow */}
//       <div
//       className={`text-black font-semibold transform transition-transform duration-500 ease-in-out ps-4 ${
//         isOpen ? "rotate-180" : "rotate-0"
//       }`}
//     >
//         ▼
//       </div>
//     </button>
//   ));

  const [isFormVisible, setIsFormVisible] = useState(false);
const formRef = useRef(null); // Create a ref for the form container

useEffect(() => {
  if (isFormVisible && formRef.current) {
    formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}, [isFormVisible]); // Trigger when isFormVisible changes

const handleOrderClick = async (startDate, endDate) => {
  
  navigate(`/daftarpemesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}&selectedDate=${localDateString(new Date(startDate))}`)

};

    
const handleDraftPOClick = async (kitchenId,startDate, endDate) => {
  //handleBuatPesanan(startDate, endDate)
  
  // navigate(`/daftarpesanan?kitchenId=${kitchenId}&startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
  navigate(`/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
  
};

const handleDraftClick = async (startDate, endDate) => {
  
  navigate(`/penerimaanbahansortbydapur?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
  //navigate(`/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
  
};

const handleScheduleClick = async (kitchen_id,startDate, endDate) => {
  
  navigate(`/menumingguan?kitchen_id=${kitchen_id}&startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
  //navigate(`/daftarpesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`)
  
};


  
const getSelectedSuppliers = () => {
  const mainSupplier = selectedRowData?.supplier_id ? [selectedRowData.supplier_id] : [];
  const additionalSelected = additionalSuppliers
    .map((supplier) => supplier.supplier_id)
    .filter((id) => id != null);
  return [...mainSupplier, ...additionalSelected];
};
  

  useEffect(() => {
    const initialSelectedSuppliers = [];
  
    // Include the first supplier if selected
    if (selectedRowData?.supplier_id) {
      initialSelectedSuppliers.push(selectedRowData.supplier_id);
    }
  
    // Include additional suppliers if selected
    additionalSuppliers.forEach((supplier) => {
      if (supplier.supplier_id) {
        initialSelectedSuppliers.push(supplier.supplier_id);
      }
    });
  
    setSelectedSuppliers(initialSelectedSuppliers);
  }, [selectedRowData, additionalSuppliers]);

  const [selectedSuppliers, setSelectedSuppliers] = useState([]); // State to track selected supplier IDs


  const adminId = localStorage.getItem('userId');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault(); // Optional: Comment this if native refresh is desired
  
    if (isSubmitting) return;
    setIsSubmitting(true);
  
    try {
      if (!locationId || !selectedRowData || !selectedRowData.date || !adminId) {
        alert("Please ensure all required fields are filled out.");
        setIsSubmitting(false);
        return;
      }
  
      const collectedSuppliers = [
        {
          supplier_id: selectedRowData.supplier_id,
          quantity: selectedRowData.supplier_quantity,
        },
        ...additionalSuppliers.map((supplier) => ({
          supplier_id: supplier.supplier_id,
          quantity: supplier.quantity,
        })),
      ].filter((supplier) => supplier.supplier_id && supplier.quantity);
  
      if (collectedSuppliers.length === 0) {
        alert("Please add valid suppliers and quantities.");
        setIsSubmitting(false);
        return;
      }
  
      const finalOrderDetails = {
        location_id: locationId,
        date: selectedRowData.date,
        ingredient_id: selectedRowData.ingredient_id,
        suppliers: collectedSuppliers.map((supplier) => supplier.supplier_id),
        orders: collectedSuppliers.map((supplier) => supplier.quantity),
        admin_id: adminId,
      };
  
      console.log("Final Payload:", finalOrderDetails);
  
      const response = await instance2.post("order_detail", finalOrderDetails);
      console.log("Order posted successfully:", response.data);
  
      setSelectedRowData([]);
      setAdditionalSuppliers([]);
      setIsFormVisible(false);
  
      // Optional: Force page reload
      window.location.reload();
    } catch (error) {
      console.error("Error posting order details:", error.response?.data || error.message);
      alert("Failed to submit order details.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  

const isFormValid = () => {
  // Check if `selectedRowData` exists and has valid `supplier_id` and `supplier_quantity`
  if (
    !selectedRowData ||
    !selectedRowData.supplier_id || 
    selectedRowData.supplier_quantity == null || 
    selectedRowData.supplier_quantity === 0
  ) {
    return false;
  }

  // Validate all additional suppliers
  for (const supplier of additionalSuppliers) {
    if (!supplier.supplier_id || supplier.quantity == null || supplier.quantity === 0) {
      return false;
    }
  }

  // If all checks pass, the form is valid
  return true;
};

const handleCreateOrder = async () => {
  try {
    const payload = {
      // Add your payload structure here
      
    admin_id: localStorage.getItem("userAuthentication") || "",
    location_id: localStorage.getItem("locationId") || "",
      startdate: startDate,
      enddate: endDate,
    };

    const response = await instance2.post("/final_order", payload); // Adjust endpoint to match your API

    if (response.status === "OK") {
      alert("Order created successfully!");
      
      // Show loading message
      setLoading(true);
    
      // Wait 5 seconds before navigating
      setTimeout(() => {
        setLoading(false); // Hide loading message
        navigate(`/daftarpemesanan?startDate=${localDateString(new Date(startDate))}&endDate=${localDateString(new Date(endDate))}`);
      }, 5000); 
    } else {
      throw new Error("Failed to create order.");
    }
  } catch (error) {
    console.error("Error creating order:", error.message || error.response?.data);
    alert("Failed to create order. Please try again.");
  }
};

const handleCloseEdit = () => {
  setIsFormVisible(false)
}
// Date state for filtering weeks
const [selectedDate, setSelectedDate] = useState(new Date());

    const [isLoading, setIsLoading] = useState(false); // Loading state
  
    // useEffect(() => {
    //   const fetchDraftOrder = async () => {
    
    //         const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
    
    //     try {
    //       setIsLoading(true)
    //       const response = await instance2.get(`order_draft_header/location/${locId}/${localDateString(startDate)}/${localDateString(endDate)}`); // Use instance2 for the API call
    //       setDraftOrder(response.data); // Axios automatically parses JSON, accessing response.data directly
    //       console.log("draftOrder", response.data)
    //     } catch (error) {
    //       console.error("Error fetching order draft:", error);
    //     } finally {
    //       setIsLoading(false); // Set loading to false after submission
    //     }
    //   };
    
    //   fetchDraftOrder();
    // }, [selectedDate]);

      
useEffect(() => {
  const fetchDraftOrder = async () => {

    try {
      setIsLoading(true)
      const response = await instance2.get(`menu_schedule_header/${locId}`); // Use instance2 for the API call
      console.log("draftOrder", response.data)
      const sortedData = response.data.sort((a, b) => b.startdate - a.startdate);

      setDraftOrder(sortedData); // Axios automatically parses JSON, accessing response.data directly
    } catch (error) {
      console.error("Error fetching order draft:", error);
    } finally {
      setIsLoading(false); // Set loading to false after submission
    }
  };

  fetchDraftOrder();

}, [locId]);


useEffect(() => {

      setFilteredData(draftOrder.sort((a, b) => {
        // Comparing by 'startdate', assuming it's a Date string or Date object
        return new Date(b.startdate) - new Date(a.startdate);
      }))
  
}, [draftOrder]);



const [weekDetails, setWeekDetails] = useState({
  weekNumber: 1,
  startDate: "",
  endDate: "",
});

// Function to get week details from a date
const getWeekDetails = (date) => {
  const currentDate = new Date(date);
  const dayOfWeek = currentDate.getDay();
  const startOfWeek = new Date(currentDate);
  startOfWeek.setDate(currentDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  return {
    weekNumber: Math.ceil(startOfWeek.getDate() / 7),
    startDate: localDateString(startOfWeek),
    endDate: localDateString(endOfWeek),
  };
};
  // Update week details when selectedDate changes
 
// Pagination logic
const totalPages = Math.ceil(draftOrder.length / itemsPerPage);
const paginatedData = draftOrder.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  // Determine which page numbers to show
  let pageNumbers = [];
  const maxVisiblePages = 5;

  if (totalPages <= maxVisiblePages) {
    pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (currentPage <= 3) {
      // Near the beginning
      pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
    } else if (currentPage >= totalPages - 2) {
      // Near the end
      pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      // In the middle
      pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
    }
  }

  
    const CustomInput = React.forwardRef(({ onClick, isOpen }, ref) => (
      <button
        className="flex flex-row items-center justify-between w-full px-4 py-2 border rounded-[15px] bg-white gap-2"
        onClick={onClick}
        ref={ref}
        type="button"
      >
        <div className="flex items-center gap-2">
          <span className="font-semibold">
            {`W${weekDetails.weekNumber} ${new Date(weekDetails.startDate).toLocaleDateString("id-ID", {
              month: "long", // For full month name in Indonesian
            })}`}
          </span>
          {` (${new Date(weekDetails.startDate).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long", // For full month name in Indonesian
            day: "2-digit",
          })} - ${new Date(weekDetails.endDate).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long", // For full month name in Indonesian
            day: "2-digit",
          })})`}
        </div>
    
        {/* Arrow Icon */}
        <div
          className="flex-shrink-0 w-6 h-6 text-black font-semibold transform transition-transform duration-500 ease-in-out"
          style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <ArrowIcon
            className={`w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5 transform ${isOpen ? "rotate-180" : "rotate-0"}`}
          />
        </div>
      </button>
    ));
  
// useEffect(() => {
//   const getNextMonday = () => {
//     const currentDate = new Date();
//     const dayOfWeek = currentDate.getDay();
//     const daysUntilNextMonday = (8 - dayOfWeek) % 7;
//     currentDate.setDate(currentDate.getDate() + daysUntilNextMonday);
//     currentDate.setHours(0, 0, 0, 0);
    
//     return currentDate;
//   };

//   // If roleId is 2, set selected date to next Monday, else this week's Monday
//   setSelectedDate(roleId === 2 ? getNextMonday() : new Date());
// }, [roleId]);

  return (
    <div className="p-4">
      
      {/* Popup Modal */}
      {isPopupVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20">
          <div className="bg-white p-6 rounded shadow-md w-1/3 text-center border rounded-[25px]">
            <h2 className="text-xl font-semibold mb-4">Pemberitahuan</h2>
            <p className="mb-4">{popupMessage}</p>
            <button
              onClick={() => setIsPopupVisible(false)}
              className="px-4 py-2 bg-merah-no hover:bg-merah-hover text-white rounded"
            >
              Tutup
            </button>
          </div>
        </div>
      )}
<div className="flex flex-row items-center justify-between mb-4">
        <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Draft Pemesanan</h2>
      </div>

      {/* Search Bar */}
      <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
  {/* <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
    <MagnificationLogo />
    <VerticalLine className="mx-1" />
    <input
      type="text"
      placeholder="Telusuri data berdasarkan periode"
      className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
      style={{
        width: `${"Telusuri data berdasarkan periode".length}ch`,
      }}
      value={searchQuery} // Controlled input
      onChange={(e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to first page on new search
      }}
    />
  </div> */}
            {/* STYLING DATEPICKER DI CUSTOMINPUT */}
            <div className="flex flex-row gap-4 items-center">
    {/* <div className="text-gray-700 font-medium text-xl text-xxs md:text-xxs lg:text-base">Pilih Minggu</div>
    <div className="relative text-xxs md:text-xxs lg:text-base">
    <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="yyyy-MM-dd"
          filterDate={(date) => {
            const day = date.getDay();
            return day !== 0 && day !== 6;
          }}
          onCalendarOpen={() => setIsOpen(true)}
          onCalendarClose={() => setIsOpen(false)}
          customInput={<CustomInput  isOpen={isOpen} />}
        />
    </div> */}
  </div>
</div>

<div className="flex flex-col items-center text-center w-full">
  <table className="w-full">
    <thead>
      <tr className="bg-white">
        <th
          className="border-b px-4 py-2 text-center rounded-tl-[15px] text-xxs md:text-xxs lg:text-base"
          rowSpan={2}
        >
          Tanggal
        </th>
        <th
          className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base"
          rowSpan={2}
        >
          Dapur
        </th>
        <th
          className="border-b px-4 py-2 rounded-tr-[15px] text-xxs md:text-xxs lg:text-base"
          rowSpan={2}
        >
          Status
        </th>
        <th
          className="border-b px-4 py-2 rounded-tr-[15px] rounded-tl-[15px] border-l-[5px] border-r-[5px] border-[#F1F2F3] text-xxs md:text-xxs lg:text-base"
          rowSpan={2} colSpan={2}
        >
          Menu
        </th>
        <th
          className="px-4 py-2 rounded-tr-[15px] rounded-tl-[15px] text-xxs md:text-xxs lg:text-base"
          colSpan={2}
        >
          Purchase Order
        </th>
      </tr>
      <tr className="bg-white">
        <th className="px-4 py-2 text-xxs md:text-xxs lg:text-base">
          Sudah Dibuat
        </th>
        <th className="px-4 py-2 text-xxs md:text-xxs lg:text-base">
          Bahan Sudah Diterima
        </th>
      </tr>
    </thead>
    <tbody>
  {paginatedData.length === 0 ? (
    <tr>
      <td colSpan="7" className="py-4 w-full text-center">
        <div className="flex justify-center items-center w-full text-gray-500 text-xxs md:text-xxs lg:text-base">
          Tidak ada data yang tersedia untuk rentang tanggal yang dipilih.
        </div>
      </td>
    </tr>
  ) : (
    [
      ...paginatedData,
      ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
        empty: true, // Add an "empty" object for invisible rows
        index: index,
      })),
    ]
      .map((item, index, arr) => {
        // Determine if we should display the date (only if it's different from the previous row)
        const showDate =
          index === 0 || // Show date for the first item
          arr[index - 1]?.startdate !== item.startdate || // If startdate is different from the previous row
          arr[index - 1]?.enddate !== item.enddate; // If enddate is different from the previous row

        // Calculate how many kitchens share the same date range (for colSpan adjustment)
        const kitchensForDate = arr.filter(
          (kitchen) =>
            kitchen.startdate === item.startdate && kitchen.enddate === item.enddate
        );
        const colspanValue = kitchensForDate.length;

        return (
          <React.Fragment key={item.index || `${item.startdate}-${item.kitchen_id}-${index}`}>
            {/* Render the date row only if it is different from the previous row */}
            {!item.empty && (
              <tr
                key={`kitchen-row-${item.startdate}-${item.kitchen_name}-${index}`}
                className={`hover:bg-gray-200 ${index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"} ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
              >
                {showDate && (
                  <td
                    rowSpan={colspanValue} // This spans the row across the number of kitchens
                    className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base"
                  >
                    {new Date(item.startdate).toLocaleDateString("id-ID", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}{" "}
                    -{" "}
                    {new Date(item.enddate).toLocaleDateString("id-ID", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </td>
                )}
                <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                  {item.kitchen_name}
                </td>
                <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                  {item.received_do_count > 0
                    ? "Sudah Didistribusi Ke Dapur"
                    : item.delivery_order_count > 0
                    ? "Sedang Didistribusi Ke Dapur"
                    : item.received_po_count > 0
                    ? "Bahan Sudah Diterima Dapur"
                    : item.po_count > 0
                    ? "Menunggu Kiriman Supplier"
                    : item.order_header > 0
                    ? "PO Sudah Dibuat"
                    : item.draft_order > 0
                    ? "Draft PO sudah Dibuat"
                    : item.schedule_count > 0
                    ? "Menu Sudah Dibuat"
                    : "Tidak Ada Menu"}
                </td>
                <td className={`text-center items-center py-2 text-xxs md:text-xxs lg:text-base border-l-[5px] border-[#F1F2F3] `}>
                  {item.schedule_count > 0 && (
                    <button 
                    className={`${roleId !== 4 ? "cursor-default" : ""}`}>
                    <ListOn
                      className={`w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 text-green-500`}
                      onClick={() =>
                        roleId === 4 || roleId === 2
                          ? handleScheduleClick(item.kitchen_id, item.startdate, item.enddate)
                          : ""
                      }
                    />
                    </button>
                  )}
                </td>

                {showDate && (
                  <td
                    rowSpan={colspanValue} // This spans the row across the number of kitchens
                    className=" px-4 py-2 text-center items-center text-xxs md:text-xxs lg:text-base border-r-[5px] border-[#F1F2F3]"
                  >
                    {item.saved_schedule === colspanValue ? (
                      // <button
                      //   className={`text-gray-500 p-2 rounded hover:text-red-400 ${roleId !== 4 ? "cursor-default" : ""}`}
                      //   onClick={() => roleId === 4 && navigate(
                      //     `/daftarpesanan?startDate=${localDateString(new Date(item.startdate))}&endDate=${localDateString(new Date(item.enddate))}`,
                      //   )
                      //     // && handleBuatPesanan(item.startdate, item.enddate)

                      //   }
                      // >
                      <div className="flex w-full items-center justify-center">
                        <ListOn className="w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 text-green-500" />
                        </div>
                      // </button>
                    ) : (
                      ""
                    )}
                    <div>{item.saved_schedule + "/" + colspanValue}</div>
                  </td>
                )}

                <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                  {item.schedule_count > 0 ? (
                    item.order_header === null || item.order_header === 0 ? (
                      <button
                        className={`text-gray-500 p-2 rounded hover:text-red-400 ${roleId !== 4 ? "cursor-pointer" : ""}`}
                        onClick={() => roleId === 4 && handleDraftPOClick(item.kitchen_id,item.startdate, item.enddate)}
                      >
                        <span className="flex gap-2">
                          Draft{" "}
                          <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5 text-red-400" />
                        </span>
                      </button>
                    ) : (
                      <button
                        className={`text-gray-500 p-2 rounded hover:text-red-400 ${roleId !== 3 ? "cursor-pointer" : ""}`}
                        onClick={() => roleId === 4 || roleId === 3 ? handleOrderClick(item.startdate, item.enddate) : "-"}
                      >
                        <ListOn className="w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 text-green-500" />
                      </button>
                    )
                  ) : (
                    "-"
                  )}
                </td>

                <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                  {item.order_id !== null && parseInt(item.received_count) !== 0 ? (
                    <button
                      className={`text-gray-500 p-2 rounded ${roleId === 3 ? "hover:text-red-400" : "cursor-default"}`}
                      onClick={() =>
                        roleId === 3
                          ? navigate(
                              `/penerimaanPO/?startDate=${localDateString(new Date(item.delivery_date))}&endDate=${localDateString(new Date(item.delivery_date))}&selectedDate=${localDateString(new Date(item.delivery_date))}`
                            )
                          : "-"
                      }
                    >
                      {item.received_po_count > 0 ? item.received_po_count + " dari " + item.po_count : ""}
                    </button>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            )}
          </React.Fragment>
        );
      })
  )}
</tbody>

  </table>

  {isLoading && (
    <div
      className="loading-container"
      style={{
        top: "70%",
      }}
    >
      <div className="loader"></div>
    </div>
  )}

  {/* Pagination Controls */}
  <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
    {/* Previous Button */}
    <button
      className={`px-2 py-2 rounded ${
        currentPage === 1
          ? "text-gray-400 cursor-not-allowed"
          : "text-gray-500 hover:text-black"
      }`}
      onClick={handlePreviousPage}
      disabled={currentPage === 1}
    >
      <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
    </button>

    {/* Page Numbers */}
    <div className="flex items-center">
      {pageNumbers.map((page, index) => (
        <span
          key={index}
          onClick={() => typeof page === "number" && setCurrentPage(page)}
          className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
            currentPage === page ? "text-black font-semibold" : "text-gray-700"
          } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
        >
          {page}
        </span>
      ))}
    </div>

    {/* Next Button */}
    <button
      className={`px-2 py-2 rounded ${
        currentPage === totalPages
          ? "text-gray-400 cursor-not-allowed"
          : "text-gray-500 hover:text-black"
      }`}
      onClick={handleNextPage}
      disabled={currentPage === totalPages}
    >
      <span className="font-bold text-lg sm:text-2xl">{">"}</span>
    </button>
  </div>
</div>
   </div>
  );
};